import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ApprovalIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_14516_136945)">
      <path
        d="M5.83317 5.83268V2.49935C5.83317 2.27834 5.92097 2.06637 6.07725 1.91009C6.23353 1.75381 6.44549 1.66602 6.6665 1.66602H17.4998C17.7208 1.66602 17.9328 1.75381 18.0891 1.91009C18.2454 2.06637 18.3332 2.27834 18.3332 2.49935V13.3327C18.3332 13.5537 18.2454 13.7657 18.0891 13.9219C17.9328 14.0782 17.7208 14.166 17.4998 14.166H14.1665V17.4935C14.1665 17.9569 13.7923 18.3327 13.3273 18.3327H2.50567C2.39544 18.3328 2.28627 18.3112 2.18441 18.269C2.08254 18.2269 1.98999 18.1651 1.91205 18.0871C1.8341 18.0092 1.77229 17.9166 1.73016 17.8148C1.68803 17.7129 1.66639 17.6037 1.6665 17.4935L1.669 6.67185C1.669 6.20852 2.04317 5.83268 2.50817 5.83268H5.83317ZM7.49984 5.83268H13.3273C13.7907 5.83268 14.1665 6.20685 14.1665 6.67185V12.4993H16.6665V3.33268H7.49984V5.83268ZM7.08567 14.9993L11.799 10.2852L10.6207 9.10685L7.08567 12.6427L5.3165 10.8743L4.13817 12.0527L7.08567 14.9993Z"
        fill="#1E96FC"
      />
    </g>
    <defs>
      <clipPath id="clip0_14516_136945">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const CloseModalIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M25.3337 8.54602L23.4537 6.66602L16.0003 14.1193L8.54699 6.66602L6.66699 8.54602L14.1203 15.9993L6.66699 23.4527L8.54699 25.3327L16.0003 17.8793L23.4537 25.3327L25.3337 23.4527L17.8803 15.9993L25.3337 8.54602Z"
      fill="#696974"
    />
  </SvgIcon>
);

export const PercentageIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M0.65625 3.24512V2.71875C0.65625 2.34049 0.738281 1.99642 0.902344 1.68652C1.06641 1.37663 1.30794 1.12826 1.62695 0.941406C1.94596 0.754557 2.33789 0.661133 2.80273 0.661133C3.28125 0.661133 3.68001 0.754557 3.99902 0.941406C4.32259 1.12826 4.56413 1.37663 4.72363 1.68652C4.8877 1.99642 4.96973 2.34049 4.96973 2.71875V3.24512C4.96973 3.61426 4.8877 3.95378 4.72363 4.26367C4.56413 4.57357 4.32487 4.82194 4.00586 5.00879C3.68685 5.19564 3.29036 5.28906 2.81641 5.28906C2.34701 5.28906 1.95052 5.19564 1.62695 5.00879C1.30794 4.82194 1.06641 4.57357 0.902344 4.26367C0.738281 3.95378 0.65625 3.61426 0.65625 3.24512ZM1.96191 2.71875V3.24512C1.96191 3.40462 1.99154 3.55729 2.05078 3.70312C2.11458 3.8444 2.21029 3.96061 2.33789 4.05176C2.47005 4.13835 2.62956 4.18164 2.81641 4.18164C3.01237 4.18164 3.17188 4.13835 3.29492 4.05176C3.41797 3.96061 3.50911 3.8444 3.56836 3.70312C3.6276 3.55729 3.65723 3.40462 3.65723 3.24512V2.71875C3.65723 2.55013 3.62533 2.39518 3.56152 2.25391C3.50228 2.10807 3.40885 1.99186 3.28125 1.90527C3.1582 1.81413 2.9987 1.76855 2.80273 1.76855C2.62044 1.76855 2.46549 1.81413 2.33789 1.90527C2.21029 1.99186 2.11458 2.10807 2.05078 2.25391C1.99154 2.39518 1.96191 2.55013 1.96191 2.71875ZM5.41406 8.84375V8.31738C5.41406 7.94368 5.49609 7.60189 5.66016 7.29199C5.82878 6.9821 6.07259 6.73372 6.3916 6.54688C6.71517 6.36003 7.11165 6.2666 7.58105 6.2666C8.05501 6.2666 8.4515 6.36003 8.77051 6.54688C9.08952 6.73372 9.33105 6.9821 9.49512 7.29199C9.65918 7.60189 9.74121 7.94368 9.74121 8.31738V8.84375C9.74121 9.21745 9.65918 9.55924 9.49512 9.86914C9.33561 10.179 9.09635 10.4274 8.77734 10.6143C8.45833 10.8011 8.06413 10.8945 7.59473 10.8945C7.12077 10.8945 6.72201 10.8011 6.39844 10.6143C6.07487 10.4274 5.82878 10.179 5.66016 9.86914C5.49609 9.55924 5.41406 9.21745 5.41406 8.84375ZM6.72656 8.31738V8.84375C6.72656 9.00781 6.76302 9.16276 6.83594 9.30859C6.90885 9.45443 7.00911 9.57064 7.13672 9.65723C7.26888 9.74382 7.42155 9.78711 7.59473 9.78711C7.81348 9.78711 7.98438 9.74382 8.10742 9.65723C8.23047 9.57064 8.31478 9.45443 8.36035 9.30859C8.41048 9.16276 8.43555 9.00781 8.43555 8.84375V8.31738C8.43555 8.15332 8.40365 8.00065 8.33984 7.85938C8.27604 7.71354 8.18034 7.59733 8.05273 7.51074C7.92969 7.4196 7.77246 7.37402 7.58105 7.37402C7.38965 7.37402 7.23014 7.4196 7.10254 7.51074C6.97949 7.59733 6.88607 7.71354 6.82227 7.85938C6.75846 8.00065 6.72656 8.15332 6.72656 8.31738ZM8.06641 2.22656L3.20605 10.0059L2.24902 9.5L7.10938 1.7207L8.06641 2.22656Z"
      fill="#92929D"
    />
  </SvgIcon>
);

export const DollarIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M4.79199 0.225586V2.24219H3.72559V0.225586H4.79199ZM4.66211 11.3887V13.2275H3.5957V11.3887H4.66211ZM5.41406 9.14648C5.41406 8.88672 5.36621 8.66569 5.27051 8.4834C5.17936 8.30111 5.02897 8.13932 4.81934 7.99805C4.61426 7.85677 4.33626 7.72005 3.98535 7.58789C3.3929 7.36003 2.87109 7.11849 2.41992 6.86328C1.97331 6.60352 1.62467 6.28223 1.37402 5.89941C1.12337 5.51204 0.998047 5.02214 0.998047 4.42969C0.998047 3.86458 1.13249 3.37467 1.40137 2.95996C1.67025 2.54525 2.04167 2.22624 2.51562 2.00293C2.99414 1.77507 3.55013 1.66113 4.18359 1.66113C4.66667 1.66113 5.10417 1.73405 5.49609 1.87988C5.88802 2.02116 6.22526 2.23079 6.50781 2.50879C6.79036 2.78223 7.00684 3.11719 7.15723 3.51367C7.30762 3.91016 7.38281 4.36361 7.38281 4.87402H5.4209C5.4209 4.60059 5.39128 4.35905 5.33203 4.14941C5.27279 3.93978 5.1862 3.76432 5.07227 3.62305C4.96289 3.48177 4.83073 3.37695 4.67578 3.30859C4.52083 3.23568 4.34993 3.19922 4.16309 3.19922C3.88509 3.19922 3.65723 3.25391 3.47949 3.36328C3.30176 3.47266 3.17188 3.62077 3.08984 3.80762C3.01237 3.98991 2.97363 4.19954 2.97363 4.43652C2.97363 4.66895 3.01465 4.87174 3.09668 5.04492C3.18327 5.2181 3.33138 5.3776 3.54102 5.52344C3.75065 5.66471 4.03776 5.81055 4.40234 5.96094C4.99479 6.1888 5.51432 6.4349 5.96094 6.69922C6.40755 6.96354 6.75618 7.28711 7.00684 7.66992C7.25749 8.05273 7.38281 8.54036 7.38281 9.13281C7.38281 9.7207 7.24609 10.222 6.97266 10.6367C6.69922 11.0469 6.31641 11.3613 5.82422 11.5801C5.33203 11.7943 4.76237 11.9014 4.11523 11.9014C3.69596 11.9014 3.27897 11.8467 2.86426 11.7373C2.44954 11.6234 2.07357 11.4411 1.73633 11.1904C1.39909 10.9398 1.13021 10.6071 0.929688 10.1924C0.729167 9.77311 0.628906 9.25814 0.628906 8.64746H2.59766C2.59766 8.98014 2.64095 9.25814 2.72754 9.48145C2.81413 9.7002 2.92806 9.87565 3.06934 10.0078C3.21517 10.1354 3.37923 10.2266 3.56152 10.2812C3.74382 10.3359 3.92839 10.3633 4.11523 10.3633C4.4069 10.3633 4.64616 10.3109 4.83301 10.2061C5.02441 10.1012 5.16797 9.95768 5.26367 9.77539C5.36393 9.58854 5.41406 9.37891 5.41406 9.14648Z"
      fill="#92929D"
    />
  </SvgIcon>
);

export const CheckmarkIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_14157_64625)">
      <path
        d="M8.33361 12.694L15.9936 5.0332L17.1728 6.21154L8.33361 15.0507L3.03027 9.74737L4.20861 8.56904L8.33361 12.694Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_14157_64625">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.0507812)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SaveFillIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_14150_61295)">
      <path
        d="M10.0003 18.3844C5.39783 18.3844 1.66699 14.6536 1.66699 10.0511C1.66699 5.44861 5.39783 1.71777 10.0003 1.71777C14.6028 1.71777 18.3337 5.44861 18.3337 10.0511C18.3337 14.6536 14.6028 18.3844 10.0003 18.3844ZM9.16949 13.3844L15.0612 7.49194L13.8828 6.31361L9.16949 11.0278L6.81199 8.67027L5.63366 9.84861L9.16949 13.3844Z"
        fill="#23A566"
      />
    </g>
    <defs>
      <clipPath id="clip0_14150_61295">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.0507812)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const EditIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_14150_61295)">
      <path
        d="M7.7025 15.8822H17.5V17.5489H2.5V14.0131L10.75 5.76306L14.285 9.29973L7.70167 15.8822H7.7025ZM11.9275 4.58556L13.6958 2.81723C13.8521 2.66101 14.064 2.57324 14.285 2.57324C14.506 2.57324 14.7179 2.66101 14.8742 2.81723L17.2317 5.17473C17.3879 5.331 17.4757 5.54293 17.4757 5.7639C17.4757 5.98487 17.3879 6.19679 17.2317 6.35306L15.4633 8.12056L11.9283 4.58556H11.9275Z"
        fill="#1E96FC"
      />
    </g>
    <defs>
      <clipPath id="clip0_14150_61295">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.0507812)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const RemoveItemIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 24.4902C19.5228 24.4902 24 20.0131 24 14.4902C24 8.96739 19.5228 4.49023 14 4.49023C8.47715 4.49023 4 8.96739 4 14.4902C4 20.0131 8.47715 24.4902 14 24.4902Z"
      fill="#FC5A5A"
    />
    <path
      d="M9.05078 15.4902H12.9739H14.9739H18.8969C20.2303 15.4902 20.2303 13.4902 18.8969 13.4902H14.9739H12.9739H9.05078C7.71745 13.4902 7.71745 15.4902 9.05078 15.4902Z"
      fill="white"
    />
  </SvgIcon>
);

export const PlusIcon = ({ fill, ...rest }: SvgIconProps) => {
  const iconColor = fill || '#B5B5BE';
  return (
    <SvgIcon
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2822 14.8428V9.34245C14.2822 8.83619 14.6926 8.42578 15.1989 8.42578C15.7052 8.42578 16.1156 8.83619 16.1156 9.34245V14.8428H21.6162C22.1225 14.8428 22.5329 15.2532 22.5329 15.7594C22.5329 16.2657 22.1225 16.6761 21.6162 16.6761H16.1156V22.1758C16.1156 22.682 15.7052 23.0924 15.1989 23.0924C14.6926 23.0924 14.2822 22.682 14.2822 22.1758V16.6761H8.78288C8.27662 16.6761 7.86621 16.2657 7.86621 15.7594C7.86621 15.2532 8.27662 14.8428 8.78288 14.8428H14.2822Z"
        fill={iconColor}
      />
    </SvgIcon>
  );
};

export const MinusIcon = ({ fill, ...rest }: SvgIconProps) => {
  const iconColor = fill || '#B5B5BE';
  return (
    <SvgIcon
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <mask
        id="mask0_14093_18169"
        maskUnits="userSpaceOnUse"
        x="3"
        y="10"
        width="16"
        height="3">
        <path
          d="M4.78288 12.6742H17.6162C18.1225 12.6742 18.5329 12.2637 18.5329 11.7575C18.5329 11.2512 18.1225 10.8408 17.6162 10.8408H4.78288C4.27662 10.8408 3.86621 11.2512 3.86621 11.7575C3.86621 12.2637 4.27662 12.6742 4.78288 12.6742Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_14093_18169)">
        <rect
          x="0.200195"
          y="0.757812"
          width="22"
          height="22"
          fill={iconColor}
        />
      </g>
    </SvgIcon>
  );
};

export const DottedNestedIndicatorIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="21"
    height="98"
    viewBox="0 0 21 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M1 0.757812V88.7578C1 93.1761 4.58172 96.7578 9 96.7578H21"
      stroke="#92929D"
      strokeDasharray="4 4"
    />
  </SvgIcon>
);

export const FillBarCodeIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="32" height="32" rx="16" fill="#1E96FC" />
    <g clipPath="url(#clip0_11844_26307)">
      <path
        d="M7.66699 9.33398H9.33366V22.6673H7.66699V9.33398ZM11.0003 9.33398H12.667V22.6673H11.0003V9.33398ZM13.5003 9.33398H16.0003V22.6673H13.5003V9.33398ZM16.8337 9.33398H18.5003V22.6673H16.8337V9.33398ZM19.3337 9.33398H21.0003V22.6673H19.3337V9.33398ZM21.8337 9.33398H24.3337V22.6673H21.8337V9.33398Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_11844_26307">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const FillTemplateIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="32" height="32" rx="16" fill="#1E96FC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.667 19.3327V9.33268H12.667V19.3327H22.667ZM22.667 20.9993H10.167C9.70675 20.9993 9.33366 21.3724 9.33366 21.8327C9.33366 22.2929 9.70675 22.666 10.167 22.666H22.667V20.9993ZM24.3337 22.666C24.3337 23.5865 23.5875 24.3327 22.667 24.3327H10.167C8.78628 24.3327 7.66699 23.2134 7.66699 21.8327V9.33268C7.66699 8.41221 8.41318 7.66602 9.33366 7.66602H22.667C23.5875 7.66602 24.3337 8.41221 24.3337 9.33268V22.666ZM9.33366 19.4749C9.59431 19.3828 9.8748 19.3327 10.167 19.3327H11.0003V9.33268H9.33366V19.4749ZM15.5731 14.7596C15.1129 14.7596 14.7398 14.3865 14.7398 13.9262C14.7398 13.466 15.1129 13.0929 15.5731 13.0929H18.0731C18.5334 13.0929 18.9065 13.466 18.9065 13.9262C18.9065 14.3865 18.5334 14.7596 18.0731 14.7596H15.5731ZM15.5731 17.2596C15.1129 17.2596 14.7398 16.8865 14.7398 16.4262C14.7398 15.966 15.1129 15.5929 15.5731 15.5929H19.7398C20.2 15.5929 20.5731 15.966 20.5731 16.4262C20.5731 16.8865 20.2 17.2596 19.7398 17.2596H15.5731Z"
      fill="white"
    />
  </SvgIcon>
);

export const FillCatalogIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="32" height="32" rx="16" fill="#1E96FC" />
    <g clipPath="url(#clip0_11844_26317)">
      <path
        d="M22.6667 25.1673H9.33333C9.11232 25.1673 8.90036 25.0795 8.74408 24.9232C8.5878 24.767 8.5 24.555 8.5 24.334V11.834C8.5 11.613 8.5878 11.401 8.74408 11.2447C8.90036 11.0884 9.11232 11.0007 9.33333 11.0007H22.6667C22.8877 11.0007 23.0996 11.0884 23.2559 11.2447C23.4122 11.401 23.5 11.613 23.5 11.834V24.334C23.5 24.555 23.4122 24.767 23.2559 24.9232C23.0996 25.0795 22.8877 25.1673 22.6667 25.1673ZM21.8333 23.5007V12.6673H10.1667V23.5007H21.8333ZM13.5 14.334V16.0007C13.5 16.6637 13.7634 17.2996 14.2322 17.7684C14.7011 18.2373 15.337 18.5007 16 18.5007C16.663 18.5007 17.2989 18.2373 17.7678 17.7684C18.2366 17.2996 18.5 16.6637 18.5 16.0007V14.334H20.1667V16.0007C20.1667 17.1057 19.7277 18.1655 18.9463 18.9469C18.1649 19.7283 17.1051 20.1673 16 20.1673C14.8949 20.1673 13.8351 19.7283 13.0537 18.9469C12.2723 18.1655 11.8333 17.1057 11.8333 16.0007V14.334H13.5Z"
        fill="white"
      />
      <path
        d="M13.5 11.0007V12.6673H11.8333V11.0007C11.8333 9.89558 12.2723 8.83577 13.0537 8.05437C13.8351 7.27297 14.8949 6.83398 16 6.83398C17.1051 6.83398 18.1649 7.27297 18.9463 8.05437C19.7277 8.83577 20.1667 9.89558 20.1667 11.0007V12.6673H18.5V11.0007C18.5 10.3376 18.2366 9.70173 17.7678 9.23288C17.2989 8.76404 16.663 8.50065 16 8.50065C15.337 8.50065 14.7011 8.76404 14.2322 9.23288C13.7634 9.70173 13.5 10.3376 13.5 11.0007Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_11844_26317">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const FillRFQIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="32" height="32" rx="16" fill="#1E96FC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0541 12.166L19.9167 10.8011V12.166H21.0541ZM23.6667 13.2709V21.2493C23.6667 22.9522 22.2862 24.3327 20.5833 24.3327H11.5833C9.88046 24.3327 8.5 22.9522 8.5 21.2493V10.7493C8.5 9.04647 9.88046 7.66602 11.5833 7.66602H18.7321C19.202 7.66602 19.6476 7.87474 19.9484 8.23572L23.2997 12.2573C23.5368 12.5418 23.6667 12.9005 23.6667 13.2709ZM22 13.8327H19.8333C18.9589 13.8327 18.25 13.1238 18.25 12.2493V9.33268H11.5833C10.8009 9.33268 10.1667 9.96695 10.1667 10.7493V21.2493C10.1667 22.0318 10.8009 22.666 11.5833 22.666H20.5833C21.3657 22.666 22 22.0318 22 21.2493V13.8327ZM11.919 18.9993H20.2476C20.387 18.9993 20.5 19.0988 20.5 19.2216V20.4438C20.5 20.5665 20.387 20.666 20.2476 20.666H11.919C11.7797 20.666 11.6667 20.5665 11.6667 20.4438V19.2216C11.6667 19.0988 11.7797 18.9993 11.919 18.9993Z"
      fill="white"
    />
  </SvgIcon>
);

export const FillSectionIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="32" height="32" rx="16" fill="#1E96FC" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8333 6.83398H18.6235C19.1262 6.83398 19.602 7.06088 19.9185 7.45147L23.1283 11.4133C23.3688 11.7102 23.5 12.0805 23.5 12.4625V21.834C23.5 23.6749 22.0076 25.1673 20.1667 25.1673H11.8333C9.99238 25.1673 8.5 23.6749 8.5 21.834V10.1673C8.5 8.32637 9.99238 6.83398 11.8333 6.83398ZM19.0208 8.9911V11.334H20.919L19.0208 8.9911ZM11.8333 8.50065C10.9129 8.50065 10.1667 9.24684 10.1667 10.1673V21.834C10.1667 22.7545 10.9129 23.5007 11.8333 23.5007H20.1667C21.0871 23.5007 21.8333 22.7545 21.8333 21.834V13.0007H19.0208C18.1004 13.0007 17.3542 12.2545 17.3542 11.334V8.50065H11.8333Z"
      fill="white"
    />
  </SvgIcon>
);

export const FillFreeHandIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <rect width="32" height="32" rx="16" fill="#1E96FC" />
    <g clipPath="url(#clip0_12671_200246)">
      <path
        d="M15.0835 7.75L23.3327 8.92917L24.511 17.1792L16.851 24.8392C16.6948 24.9954 16.4828 25.0832 16.2619 25.0832C16.0409 25.0832 15.829 24.9954 15.6727 24.8392L7.4227 16.5892C7.26647 16.4329 7.17871 16.221 7.17871 16C7.17871 15.779 7.26647 15.5671 7.4227 15.4108L15.0835 7.75ZM15.6727 9.51833L9.1902 16L16.2619 23.0708L22.7435 16.5892L21.8602 10.4017L15.6727 9.51833ZM17.4394 14.8217C17.1267 14.5089 16.9512 14.0848 16.9512 13.6426C16.9513 13.4237 16.9944 13.2069 17.0783 13.0046C17.1621 12.8023 17.2849 12.6185 17.4398 12.4637C17.5946 12.309 17.7785 12.1862 17.9808 12.1024C18.1831 12.0187 18.3999 11.9756 18.6188 11.9756C19.061 11.9757 19.4851 12.1514 19.7977 12.4642C20.1103 12.7769 20.2859 13.201 20.2858 13.6432C20.2858 14.0854 20.11 14.5095 19.7973 14.8221C19.4845 15.1347 19.0604 15.3103 18.6182 15.3102C18.176 15.3101 17.752 15.1344 17.4394 14.8217Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12671_200246">
        <rect width="20" height="20" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
